import { Box } from '@mui/material';

import { colors } from '../../theme';

const FilterContainer = (props: any) => {
    return (
        <Box
            sx={{
                background: colors.white,
                borderRadius: '5px',
                boxShadow: ' 0px 2px 10px rgba(0, 0, 0, 0.05)',
                p: '8px 12px',
                display: 'flex',
                // alignItems: 'center',
                '& > *': {
                    mr: '10px',
                    display: 'flex',
                },
                ...props.sx,
            }}
        >
            {props.children}
        </Box>
    );
};

export default FilterContainer;
